import { useEffect, useState } from "react";

export function useDebounce<T>(value: T, delayMilliseconds: number = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delayMilliseconds);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delayMilliseconds]);

  return debouncedValue;
}
